module.exports = __webpack_public_path__ + "static/media/frontpage-heading.dfab6220.png";